module.exports = __webpack_public_path__ + "img/sx.8db7b1d.svg";